module.exports = __webpack_public_path__ + "img/yesAdd.6b8eb008.png";